<template>
  <div>
    <el-dialog
      class="loginDiaBox"
      :before-close="setShowData"
      :visible.sync="!!$store.state.showLoginDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDia-inner">
        <el-button
          type="text"
          class="loginDia-close"
          icon="el-icon-close"
          aria-label="关闭"
          @click="setShowData"
        />
        <div class="LoginBox">
          <loginBB :isDia="true" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import loginBB from "@/views/login/login.vue";
export default {
  data() {
    return {};
  },
  components: {
    loginBB,
  },
  computed: {},
  created() {},
  methods: {
    setShowData() {
      this.$store.commit("getshowLoginDialog", false);
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.loginDiaBox {
  /deep/.el-dialog {
    width: max-content;
    border-radius: 16px;
    overflow: hidden;
  }
  /deep/.el-dialog__header {
    // display: none;
    padding: 0;
  }
  /deep/.el-dialog__body {
    padding: 0;
  }
  /deep/.el-dialog__close {
    display: none;
  }
}
.loginDia-inner {
  position: relative;
}
.loginDia-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  padding: 4px;
  font-size: 20px;
  color: #909399;
  &:hover {
    color: #344054;
  }
}
</style>
